import Component from '../../../../../ui-components/Component';
import Styles from './styles';
import { withResizer, withTranslations } from '../../../../../HoCs';
import React from 'react';
import view from '../../../../../Enums';
import { Link } from 'react-router-dom';
import stageMap from './../../config';

class ContractSigning extends Component {
    
    styles = Styles;
    translation_key = 'properties_translations';
    
    render() {
        return (
            <>
    
                <div style={this.gs('instruction_box')}>
                    <div style={this.gs('instruction_left')}>{this.gc('this_step_includes')}</div>
                    <div style={this.gs('instruction_right')}>
                        <div style={this.gs('content_parent')}>
                            <ol style={this.gs('ol')}>
                                <li style={this.gs('instruction_title')}>{this.gc('contract_terms_and')}</li>
                                <li style={this.gs('instruction_title')}>{this.gc('contract_e-acceptance')}</li>
                                <li style={this.gs('instruction_title')}>{this.gc('sharing_your_personal')}</li>
                            </ol>
                        </div>
                    </div>
                </div>
    
                <div style={this.gs('instruction_box')}>
                    <div style={this.gs('instruction_left')}>Instructions</div>
                    <div style={this.gs('instruction_right')}>
                        <div style={this.gs('content_parent')}>
                            <ol style={this.gs('ol')}>
                                <li style={this.gs('instruction_title')}>{this.gc('oyo_business_representative_contract')}</li>
                                <li style={this.gs('instruction_title')}>{this.gc('he_she_will_also')}</li>
                                <li style={this.gs('instruction_title')}>{this.gc('please_make_sure')}</li>
                            </ol>
                        </div>
                    </div>
                </div>
    
                <div style={{...this.gs('instruction_box'),...(this.getViewMode() == view.MOBILE ?{borderBottom:''}:{})}}>
                    <div style={this.gs('instruction_left')}>{this.gc('trivia_for_you')}</div>
                    <div style={this.gs('instruction_right')}>
                        <div style={this.gs('content_parent')}>
                            <div style={this.gs('instruction_title')}>{this.gc('have_a_look')}</div>
                        </div>
                        
                        <a href={this.gc('sample_report_link')} target='_blank' download={'recons_summary_sample.pdf'} style={this.gs('action_btn')}>{this.gc('view_sample_report')}</a>
                    </div>
                </div>
            </>
        );
    }
}

export default withResizer(withTranslations(ContractSigning));